import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=5a556bca&scoped=true&"
import script from "./FormModal.vue?vue&type=script&lang=ts&"
export * from "./FormModal.vue?vue&type=script&lang=ts&"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=5a556bca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a556bca",
  null
  
)

export default component.exports